export default "__VITE_ASSET__DzwOJ_Ea__"